import React, { Component } from "react";
import Firebase from "firebase";
import "firebase/functions";
import Moment from "moment";
import "moment/locale/es";
import { withRouter } from "react-router-dom";
import Message from "../../components/Message";
import Cal from "../../helper/Calendar";
import { withTranslation } from "react-i18next";
import lang from "i18next";
import EventEmitter from "../../helper/Emitter";

class MemberTrialPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      status: "disabled",
      name: "PT Mate",
      desc: "",
      color: "default",
      avatar: "",
      image: "",
      imageURL: "",
      video: "",
      sessions: [],
      events: [],
      currentDay: Moment().format("D"),
      days: [],
      empty: [],
      months: ["", ""],
      selected: Moment().format("DD/MM/YYYY"),
      today: [],
      num: 99,
      done: false,
      week: "this",
      // Field inputs
      showOverlay: false,
      hidden: "hidden",
      margin: 0,
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      error: [false, false],
      sessionSelected: "",
      mtitle: "",
      mtext: "",
      showOverlayConfirm: false,
      hiddenConfirm: "hidden",
      emptyLabel: lang.t("admin:trial.loading"),
    };
  }

  componentDidMount() {
    document.title = "Book a Session - " + this.state.name;
    window.scrollTo(0, 0);

    Moment.updateLocale("en", {
      week: {
        dow: 1, // First day of week is Monday
      },
    });

    var pathname = this.props.location.pathname;
    if (pathname.endsWith("/")) {
      pathname = pathname.slice(0, -1);
    }
    var arr = pathname.split("/");
    this.setState(
      {
        id: arr[arr.length - 1],
      },
      () => {
        this.loadSpace();
        this.loadSessions();
      },
    );
    EventEmitter.subscribe("publicLoaded", (event) => this.configureData());
    EventEmitter.subscribe("publicSessionsLoaded", (event) =>
      this.configureData(),
    );

    setTimeout(() => {
      this.setState({ emptyLabel: lang.t("admin:trial.empty") });
    }, 5500);

    this.setState({
      done: true,
    });
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe("publicLoaded", () => {});
    EventEmitter.unsubscribe("publicSessionsLoaded", () => {});
  }

  loadSpace() {
    let itemsRef = Firebase.database().ref("/public/" + this.state.id);
    itemsRef.on("value", function (snapshot) {
      if (snapshot.exists()) {
        var data = snapshot.val();
        global.publicData.push({
          status: data.status,
          name: data.name,
          desc: data.desc,
          color: data.color,
          logo: data.logo,
          video: data.video,
          email: data.email,
        });
      }
      EventEmitter.dispatch("publicLoaded", "loaded");
    });
  }

  loadSessions() {
    let itemsRef = Firebase.database().ref("/sessions/" + this.state.id);
    itemsRef.on("value", (snap) => {
      global.sessions = [];
      snap.forEach((child) => {
        var group = child.val().group;
        var date = child.val().timestamp;
        var add = false;
        var memberships = [];
        var invitees = [];
        var groups = [];
        if (child.val().invitees !== undefined) {
          invitees = child.val().invitees;
        }
        if (child.val().groups !== undefined) {
          groups = child.val().groups;
        }
        if (child.val().memberships !== undefined) {
          memberships = child.val().memberships;
        }
        if (
          groups.length === 0 &&
          invitees.length === 0 &&
          memberships.length === 0
        ) {
          add = true;
        }
        if (group && Moment(date, "X") > Moment() && add) {
          global.sessions.push({
            id: child.key,
            data: child.val(),
          });
        }
      });
      EventEmitter.dispatch("publicSessionsLoaded", "loaded");
    });
    let itemsRef2 = Firebase.database().ref("/events/" + this.state.id);
    itemsRef2.on("value", (snap) => {
      global.events = [];
      snap.forEach((child) => {
        var bookable = child.val().bookable;
        var date = child.val().timestamp;
        var add = false;
        var memberships = [];
        var invitees = [];
        var groups = [];
        if (child.val().invitees !== undefined) {
          invitees = child.val().invitees;
        }
        if (child.val().groups !== undefined) {
          groups = child.val().groups;
        }
        if (child.val().memberships !== undefined) {
          memberships = child.val().memberships;
        }
        if (
          groups.length === 0 &&
          invitees.length === 0 &&
          memberships.length === 0
        ) {
          add = true;
        }
        if (bookable && Moment(date, "X") > Moment() && add) {
          global.events.push({
            id: child.key,
            data: child.val(),
          });
        }
      });
      EventEmitter.dispatch("publicSessionsLoaded", "loaded");
    });
  }

  configureData() {
    if (global.publicData.length > 0) {
      var image = "";
      if (global.publicData[0].logo !== undefined) {
        image = global.publicData[0].logo;
      }
      this.setState(
        {
          status: global.publicData[0].status,
          name: global.publicData[0].name,
          desc: global.publicData[0].desc,
          color: global.publicData[0].color,
          image: image,
          video: global.publicData[0].video,
          sessions: global.sessions,
          events: global.events,
          imageURL: "/img/public-" + global.publicData[0].color + ".svg",
        },
        () => {
          document.title =
            lang.t("admin:page.booksession") + " - " + this.state.name;
          //this.setSelected(this.state.currentDay)
          this.getLogo();
          this.selectWeek(this.state.week);
        },
      );
    }
  }

  selectWeek(value) {
    var date = Moment().startOf("week").format("DD/MM/YYYY");
    if (value === "next") {
      date = Moment().add(7, "days").startOf("week").format("DD/MM/YYYY");
    }
    if (value === "three") {
      date = Moment().add(14, "days").startOf("week").format("DD/MM/YYYY");
    }
    if (value === "four") {
      date = Moment().add(21, "days").startOf("week").format("DD/MM/YYYY");
    }
    this.setState({
      week: value,
      selected: date,
    });
  }

  getBg() {
    var label = "image";
    if (this.state.num === 99) {
      var num = parseInt(Math.random() * 6 + 1);
      global.num = num;
      this.setState({
        num: num,
      });
    }
    label = "image bg" + this.state.num;
    return label;
  }

  getClientNameAvail(session) {
    var label = lang.t("admin:trial.booked");
    return label;
  }

  getLogo() {
    if (this.state.image !== "") {
      Firebase.storage()
        .ref()
        .child(global.publicData[0].logo)
        .getDownloadURL()
        .then((url) => {
          this.setState({
            imageURL: url,
          });
        })
        .catch((error) => {
          this.setState({
            imageURL: "",
          });
        });
    } else {
      this.setState({
        imageURL: "",
      });
    }
  }

  getSessionVirtual(item) {
    if (item.data.link !== undefined && item.data.link !== "") {
      return (
        <span>
          <img src="/img/cam.svg" alt="Virtual" className="show-light" />
          <img src="/img/cam-dark.svg" alt="Virtual" className="show-dark" />
        </span>
      );
    }
  }

  getSessionsDay(day, starttime, endtime) {
    if (!this.state.loading) {
      var week = Moment(this.state.selected, "DD/MM/YYYY")
        .startOf("week")
        .format("DD/MM/YYYY");
      var array = [];
      var farray = [];
      var date = Moment(week, "DD/MM/YYYY")
        .add(day, "days")
        .format("DD/MM/YYYY");
      //var time = '12:00'
      var start = Moment(date + " " + starttime, "DD/MM/YYYY HH:mm");
      var end = Moment(date + " " + endtime, "DD/MM/YYYY HH:mm");
      for (var item of this.state.sessions) {
        if (
          Moment(item.data.timestamp, "X") >= start &&
          Moment(item.data.timestamp, "X") < end &&
          item.data.availability === undefined
        ) {
          array.push(item);
          farray.push(item);
        }
      }
      array.sort(
        (a, b) =>
          Moment(a.data.date, "DD/MM/YYYY HH:mm") -
          Moment(b.data.date, "DD/MM/YYYY HH:mm"),
      );

      var array2 = [];
      for (var item2 of this.state.sessions) {
        if (
          Moment(item2.data.timestamp, "X") >= start &&
          Moment(item2.data.timestamp, "X") < end &&
          item2.data.availability
        ) {
          if (item2.data.clients === undefined) {
            array2.push(item2);
            farray.push(item2);
          } else {
            if (item2.data.clients.length === 0) {
              array2.push(item2);
              farray.push(item2);
            }
          }
        }
      }
      array2.sort(
        (a, b) =>
          Moment(a.data.date, "DD/MM/YYYY HH:mm") -
          Moment(b.data.date, "DD/MM/YYYY HH:mm"),
      );

      var array3 = [];
      for (var item3 of this.state.events) {
        if (
          Moment(item3.data.timestamp, "X") >= start &&
          Moment(item3.data.timestamp, "X") < end
        ) {
          array3.push(item3);
          farray.push(item3);
        }
      }
      array3.sort(
        (a, b) =>
          Moment(a.data.date, "DD/MM/YYYY HH:mm") -
          Moment(b.data.date, "DD/MM/YYYY HH:mm"),
      );
      farray.sort(
        (a, b) =>
          Moment(a.data.date, "DD/MM/YYYY HH:mm") -
          Moment(b.data.date, "DD/MM/YYYY HH:mm"),
      );

      /*return (
      <div>
        {array.map(item => (
          <div className="cal-session" key={item.id} onClick={() => this.showOverlay(item.id)}>
            <div className="icon clear primary">
              <div className="inner group"></div>
            </div>
            <p className="lft"><strong>{this.getSessionName(item)}{this.getSessionVirtual(item)}</strong><br/>{Moment(item.data.timestamp, 'X').locale(lang.language).format('LT')} - {Cal.getDuration(item.data.duration)}</p>
            <div className="clear"></div>
          </div>
        ))}
        {array2.map(item => (
          <div className="cal-session" key={item.id} onClick={() => this.showOverlay(item.id)}>
            <div className="icon clear secondary">
              <div className="inner session"></div>
            </div>
            <p className="lft"><strong>{lang.t('calendar:session.available')}{this.getSessionVirtual(item)}</strong><br/>{Moment(item.data.timestamp, 'X').locale(lang.language).format('LT')} - {Cal.getDuration(item.data.duration)}</p>
            <div className="clear"></div>
          </div>
        ))}
        {array3.map(item => (
          <div className="cal-session" key={item.id} onClick={() => this.showOverlay(item.id)}>
            <div className="icon clear quarternary">
              <div className="inner session"></div>
            </div>
            <p className="lft"><strong>{item.data.title}{this.getSessionVirtual(item)}</strong><br/>{Moment(item.data.timestamp, 'X').locale(lang.language).format('LT')} - {Cal.getDuration(item.data.duration)}</p>
            <div className="clear"></div>
          </div>
        ))}
      </div>
    )}*/
      return (
        <div>
          {farray.map((item) => (
            <div
              className="cal-session"
              key={item.id}
              onClick={() => this.showOverlay(item.id)}
            >
              {this.getSessionIcon(item)}
              <p className="lft">
                <strong>
                  {this.getSessionName(item)}
                  {this.getSessionVirtual(item)}
                </strong>
                <br />
                {this.getSessionTime(item)} -{" "}
                {Cal.getDuration(item.data.duration)}
              </p>
              <div className="clear"></div>
            </div>
          ))}
        </div>
      );
    }
  }

  getSessionName(item) {
    var label = lang.t("calendar:session.group");
    if (item.data.group && item.data.client !== "") {
      label = item.data.client;
    }
    if (!item.data.group) {
      label = lang.t("calendar:session.11");
    }
    if (item.data.link !== "") {
      label += " (" + lang.t("calendar:label.virtual") + ")";
    }
    if (item.data.title !== undefined) {
      label = item.data.title;
    }
    if (item.data.availability && item.data.group) {
      label = lang.t("calendar:session.available");
    }
    return label;
  }

  getSessionIcon(item) {
    if (item.data.title === undefined) {
      if (item.data.availability) {
        return (
          <div className="icon clear secondary">
            <div className="inner session"></div>
          </div>
        );
      } else {
        return (
          <div className="icon clear primary">
            <div className="inner group"></div>
          </div>
        );
      }
    } else {
      return (
        <div className="icon clear quarternary">
          <div className="inner event"></div>
        </div>
      );
    }
  }

  getSessionTime(item) {
    var label = Moment(item.data.date, "DD/MM/YYYY - HH:mm")
      .locale(lang.language)
      .format("LT");
    if (item.data.timestamp !== undefined) {
      label = Moment(item.data.timestamp, "X")
        .locale(lang.language)
        .format("LT");
    }
    return label;
  }

  // Booking overlay ------------------------------------------------------------

  showOverlay(item) {
    var title = lang.t("modals:public1.title1");
    var text =
      lang.t("modals:public1.text1") + " " + this.getSessionDetails(item) + ".";
    if (item === "") {
      title = lang.t("modals:public1.title2");
      text = lang.t("modals:public1.text2");
    }
    this.setState({ showOverlay: true });
    setTimeout(() => {
      const height = this.divElement.clientHeight;
      this.setState({
        hidden: "",
        margin: -height / 2,
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        sessionSelected: item,
        mtitle: title,
        mtext: text,
        error: [false, false],
      });
    }, 100);
  }

  hideOverlay() {
    const height = this.divElement.clientHeight;
    this.setState({
      hidden: "hidden",
      margin: -height / 2 + 100,
    });
    setTimeout(() => {
      this.setState({ showOverlay: false });
    }, 500);
  }

  getSessionDetails(session) {
    var label = lang.t("modals:public1.groupsession");
    for (var item of this.state.sessions) {
      if (item.id === session) {
        if (item.data.client !== "") {
          label =
            item.data.client +
            " " +
            Moment(item.data.timestamp, "X")
              .locale(lang.language)
              .format("LLL");
        } else {
          label =
            lang.t("modals:public1.groupsession") +
            " " +
            Moment(item.data.timestamp, "X")
              .locale(lang.language)
              .format("LLL");
        }
        if (item.data.availability) {
          label =
            lang.t("modals:public1.available") +
            " " +
            Moment(item.data.timestamp, "X")
              .locale(lang.language)
              .format("LLL");
        }
      }
    }
    for (var item2 of this.state.events) {
      if (item2.id === session) {
        label =
          item2.data.title +
          " " +
          Moment(item2.data.timestamp, "X").locale(lang.language).format("LLL");
      }
    }
    return label;
  }

  renderOverlay() {
    if (this.state.showOverlay) {
      return (
        <div
          className={"overlay " + this.state.color + " " + this.state.hidden}
        >
          <div
            className="box auto"
            ref={(divElement) => {
              this.divElement = divElement;
            }}
            style={{ marginTop: this.state.margin }}
          >
            <h2 className="mb-20 lft">{this.state.mtitle}</h2>
            <button
              className={"btn tertiary small close rgt " + this.state.color}
              onClick={() => this.hideOverlay()}
            >
              {lang.t("common:button.close")}
            </button>
            <p className="clear mb-30">{this.state.mtext}</p>
            <label className={this.state.error[0] ? "error" : ""}>
              {lang.t("modals:public1.name")}*
            </label>
            <input
              type="text"
              value={this.state.value1}
              name="value1"
              onChange={this.onChange}
              className={this.state.error[0] ? "error" : ""}
            />
            <div className="sv-20"></div>
            <label className={this.state.error[1] ? "error" : ""}>
              {lang.t("modals:public1.phone")}*
            </label>
            <input
              type="number"
              value={this.state.value2}
              name="value2"
              onChange={this.onChange}
              className={this.state.error[1] ? "error" : ""}
            />
            <div className="sv-20"></div>
            <label>{lang.t("modals:public1.email")}</label>
            <input
              type="email"
              value={this.state.value3}
              name="value3"
              onChange={this.onChange}
            />
            <div className="sv-20"></div>
            <label>{lang.t("modals:public1.comments")}</label>
            <textarea
              value={this.state.value4}
              name="value4"
              onChange={this.onChange}
            ></textarea>
            <div className="clear mb-30"></div>
            <button
              className={"btn primary " + this.state.color}
              onClick={() => this.sendRequest()}
            >
              {lang.t("modals:public1.button")}
            </button>
          </div>
        </div>
      );
    }
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  async sendRequest() {
    if (this.state.value1 !== "" && this.state.value2 !== "") {
      this.hideOverlay();
      await Firebase.database()
        .ref("/public/" + this.state.id + "/requests")
        .push({
          name: this.state.value1,
          phone: this.state.value2,
          email: this.state.value3,
          notes: this.state.value4,
          session: this.state.sessionSelected,
          sent: Moment().format("DD/MM/YYYY HH:mm"),
          status: "new",
        })
        .then(() => {
          EventEmitter.dispatch(
            "showMessage",
            lang.t("messaging:message.requestsent"),
          );
          setTimeout(() => {
            this.showOverlayConfirmation();
          }, 500);
        })
        .catch((error) => {
          EventEmitter.dispatch("showMessageError", error.message);
        });
      // Email confirmation
      if (
        global.publicData[0].email !== undefined &&
        global.publicData[0].email !== ""
      ) {
        var comments = this.state.value4;
        if (this.state.sessionSelected !== "") {
          for (var item of global.sessions) {
            if (item.id === this.state.sessionSelected) {
              comments =
                "Class - " +
                Moment(item.data.timestamp, "X").format("LLLL") +
                "\n" +
                this.state.value4;
              if (item.data.client !== "") {
                comments =
                  item.data.client +
                  " - " +
                  Moment(item.data.timestamp, "X").format("LLLL") +
                  "\n" +
                  this.state.value4;
              }
              if (item.data.availability) {
                comments =
                  "1:1 Availability - " +
                  Moment(item.data.timestamp, "X").format("LLLL") +
                  "\n" +
                  this.state.value4;
              }
            }
          }
        }
        var callFunction = Firebase.functions().httpsCallable("sendLeadV2");
        callFunction({
          to: global.publicData[0].email,
          name: this.state.value1,
          phone: this.state.value2,
          email: this.state.value3,
          comments: comments,
        }).then(function (result) {});
      }
    } else {
      var error = [false, false];
      if (this.state.value1 === "") {
        error[0] = true;
      }
      if (this.state.value2 === "") {
        error[1] = true;
      }
      this.setState({
        error: error,
      });
    }
  }

  showOverlayConfirmation(item) {
    this.setState({ showOverlayConfirm: true });
    setTimeout(() => {
      const height = this.divElement.clientHeight;
      this.setState({
        hiddenConfirm: "",
        margin: -height / 2,
      });
    }, 100);
  }

  hideOverlayConfirmation() {
    const height = this.divElement.clientHeight;
    this.setState({
      hiddenConfirm: "hidden",
      margin: -height / 2 + 100,
    });
    setTimeout(() => {
      this.setState({ showOverlayConfirm: false });
    }, 500);
  }

  renderOverlayConfirm() {
    if (this.state.showOverlayConfirm) {
      return (
        <div
          className={
            "overlay " + this.state.color + " " + this.state.hiddenConfirm
          }
        >
          <div
            className="box auto"
            ref={(divElement) => {
              this.divElement = divElement;
            }}
            style={{ marginTop: this.state.margin }}
          >
            <h2 className="mb-20 lft">{lang.t("modals:public2.title")}</h2>
            <button
              className={"btn tertiary small close rgt " + this.state.color}
              onClick={() => this.hideOverlayConfirmation()}
            >
              {lang.t("common:button.close")}
            </button>
            <p className="clear mb-30">
              {lang.t("modals:public2.text1")}. {this.state.name}{" "}
              {lang.t("modals:public2.text2")}
            </p>
            <button
              className={"btn primary " + this.state.color}
              onClick={() => this.hideOverlayConfirmation()}
            >
              {lang.t("modals:public2.button")}
            </button>
          </div>
        </div>
      );
    }
  }

  // Display stuff ------------------------------------------------------------

  getWeekDate(num) {
    var label = "1 Jan";
    var week = Moment(this.state.selected, "DD/MM/YYYY").startOf("week");
    label = Moment(week).add(num, "days").locale(lang.language).format("D MMM");
    if (
      Moment(week).add(num, "days").format("D MM YYYY") ===
      Moment().format("D MM YYYY")
    ) {
      label = lang.t("calendar:label.today");
    }
    return label;
  }

  getDayClass(type, day) {
    var label = "";
    if (type === "week") {
      var week = Moment(this.state.selected, "DD/MM/YYYY").startOf("week");
      if (
        Moment(week).add(day, "days").format("D MM YYYY") ===
        Moment().format("D MM YYYY")
      ) {
        label = lang.t("calendar:label.today-s");
      }
    } else if (type === "month") {
      var second = Moment()
        .startOf("month")
        .add(this.state.current - 1, "months")
        .format("MM/YYYY");
      var dy2 = Moment(day + "/" + second, "D/MM/YYYY").format("D MM YYYY");
      if (dy2 === Moment().format("D MM YYYY")) {
        label = lang.t("calendar:label.today-s");
      }
    }
    return label;
  }

  renderContent() {
    return (
      <div>
        <div className="listheader">
          <h3>
            {Moment(this.state.selected, "DD/MM/YYYY").format("D MMM")} -{" "}
            {Moment(this.state.selected, "DD/MM/YYYY")
              .add(6, "days")
              .locale(lang.language)
              .format("D MMM")}
          </h3>
          <div className="clear"></div>
        </div>
        <div className="calendar">
          <div style={{ minWidth: "800px" }}>
            <div
              className={"weekday lft cal-top " + this.getDayClass("week", 0)}
            >
              <h3>
                {lang.t("calendar:label.mon")}{" "}
                <span>{this.getWeekDate(0)}</span>
              </h3>
            </div>
            <div
              className={"weekday lft cal-top " + this.getDayClass("week", 1)}
            >
              <h3>
                {lang.t("calendar:label.tue")}{" "}
                <span>{this.getWeekDate(1)}</span>
              </h3>
            </div>
            <div
              className={"weekday lft cal-top " + this.getDayClass("week", 2)}
            >
              <h3>
                {lang.t("calendar:label.wed")}{" "}
                <span>{this.getWeekDate(2)}</span>
              </h3>
            </div>
            <div
              className={"weekday lft cal-top " + this.getDayClass("week", 3)}
            >
              <h3>
                {lang.t("calendar:label.thu")}{" "}
                <span>{this.getWeekDate(3)}</span>
              </h3>
            </div>
            <div
              className={"weekday lft cal-top " + this.getDayClass("week", 4)}
            >
              <h3>
                {lang.t("calendar:label.fri")}{" "}
                <span>{this.getWeekDate(4)}</span>
              </h3>
            </div>
            <div
              className={"weekday lft cal-top " + this.getDayClass("week", 5)}
            >
              <h3>
                {lang.t("calendar:label.sat")}{" "}
                <span>{this.getWeekDate(5)}</span>
              </h3>
            </div>
            <div
              className={"weekday lft cal-top " + this.getDayClass("week", 6)}
            >
              <h3>
                {lang.t("calendar:label.sun")}{" "}
                <span>{this.getWeekDate(6)}</span>
              </h3>
            </div>
            <div className="clear"></div>

            <div style={{ display: "flex" }}>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 0)}
              >
                <h4>{lang.t("calendar:label.morning")}</h4>
                {this.getSessionsDay(0, "00:00", "12:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 1)}
              >
                <h4>{lang.t("calendar:label.morning")}</h4>
                {this.getSessionsDay(1, "00:00", "12:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 2)}
              >
                <h4>{lang.t("calendar:label.morning")}</h4>
                {this.getSessionsDay(2, "00:00", "12:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 3)}
              >
                <h4>{lang.t("calendar:label.morning")}</h4>
                {this.getSessionsDay(3, "00:00", "12:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 4)}
              >
                <h4>{lang.t("calendar:label.morning")}</h4>
                {this.getSessionsDay(4, "00:00", "12:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 5)}
              >
                <h4>{lang.t("calendar:label.morning")}</h4>
                {this.getSessionsDay(5, "00:00", "12:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 6)}
              >
                <h4>{lang.t("calendar:label.morning")}</h4>
                {this.getSessionsDay(6, "00:00", "12:00")}
              </div>
            </div>
            <div className="clear"></div>

            <div style={{ display: "flex" }}>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 0)}
              >
                <h4>{lang.t("calendar:label.midday")}</h4>
                {this.getSessionsDay(0, "12:00", "14:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 1)}
              >
                <h4>{lang.t("calendar:label.midday")}</h4>
                {this.getSessionsDay(1, "12:00", "14:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 2)}
              >
                <h4>{lang.t("calendar:label.midday")}</h4>
                {this.getSessionsDay(2, "12:00", "14:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 3)}
              >
                <h4>{lang.t("calendar:label.midday")}</h4>
                {this.getSessionsDay(3, "12:00", "14:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 4)}
              >
                <h4>{lang.t("calendar:label.midday")}</h4>
                {this.getSessionsDay(4, "12:00", "14:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 5)}
              >
                <h4>{lang.t("calendar:label.midday")}</h4>
                {this.getSessionsDay(5, "12:00", "14:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 6)}
              >
                <h4>{lang.t("calendar:label.midday")}</h4>
                {this.getSessionsDay(6, "12:00", "14:00")}
              </div>
            </div>
            <div className="clear"></div>

            <div style={{ display: "flex" }}>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 0)}
              >
                <h4>{lang.t("calendar:label.afternoon")}</h4>
                {this.getSessionsDay(0, "14:00", "18:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 1)}
              >
                <h4>{lang.t("calendar:label.afternoon")}</h4>
                {this.getSessionsDay(1, "14:00", "18:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 2)}
              >
                <h4>{lang.t("calendar:label.afternoon")}</h4>
                {this.getSessionsDay(2, "14:00", "18:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 3)}
              >
                <h4>{lang.t("calendar:label.afternoon")}</h4>
                {this.getSessionsDay(3, "14:00", "18:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 4)}
              >
                <h4>{lang.t("calendar:label.afternoon")}</h4>
                {this.getSessionsDay(4, "14:00", "18:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 5)}
              >
                <h4>{lang.t("calendar:label.afternoon")}</h4>
                {this.getSessionsDay(5, "14:00", "18:00")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 6)}
              >
                <h4>{lang.t("calendar:label.afternoon")}</h4>
                {this.getSessionsDay(6, "14:00", "18:00")}
              </div>
            </div>
            <div className="clear"></div>

            <div style={{ display: "flex" }}>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 0)}
              >
                <h4>{lang.t("calendar:label.evening")}</h4>
                {this.getSessionsDay(0, "18:00", "23:59")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 1)}
              >
                <h4>{lang.t("calendar:label.evening")}</h4>
                {this.getSessionsDay(1, "18:00", "23:59")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 2)}
              >
                <h4>{lang.t("calendar:label.evening")}</h4>
                {this.getSessionsDay(2, "18:00", "23:59")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 3)}
              >
                <h4>{lang.t("calendar:label.evening")}</h4>
                {this.getSessionsDay(3, "18:00", "23:59")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 4)}
              >
                <h4>{lang.t("calendar:label.evening")}</h4>
                {this.getSessionsDay(4, "18:00", "23:59")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 5)}
              >
                <h4>{lang.t("calendar:label.evening")}</h4>
                {this.getSessionsDay(5, "18:00", "23:59")}
              </div>
              <div
                className={"weekday cal-data " + this.getDayClass("week", 6)}
              >
                <h4>{lang.t("calendar:label.evening")}</h4>
                {this.getSessionsDay(6, "18:00", "23:59")}
              </div>
            </div>
            <div className="clear"></div>
          </div>
        </div>
        <div className="clear sv-40"></div>
      </div>
    );
  }

  renderBase() {
    if (this.state.status === "disabled" || this.state.status === undefined) {
      return (
        <div>
          <div className="content">
            <p className="empty">{this.state.emptyLabel}</p>
          </div>
        </div>
      );
    } else {
      return (
        <div className={"theme-" + this.state.color}>
          <div className="content">
            <div className="member-header">
              <div className={this.getBg()}>
                <div className={"gradient theme-" + this.state.color}></div>
              </div>
              <div className="member-main">
                <div className="business">
                  <div
                    className="avatar"
                    style={{
                      backgroundImage: "url(" + this.state.imageURL + ")",
                    }}
                  >
                    {" "}
                  </div>
                  <h3>
                    {this.state.name}
                    <br />
                    <span>{lang.t("admin:trial.title")}</span>
                  </h3>
                </div>
                <p>
                  {this.state.desc === ""
                    ? lang.t("admin:trial.text1") +
                      " " +
                      this.state.name +
                      " " +
                      lang.t("admin:trial.text2")
                    : this.state.desc}
                </p>
                <div className="sv-30"></div>
                <div
                  className={this.state.week === "this" ? "tab active" : "tab"}
                  onClick={() => this.selectWeek("this")}
                >
                  <p>{lang.t("calendar:form.thisweek")}</p>
                  <div className="bg"></div>
                </div>
                <div
                  className={this.state.week === "next" ? "tab active" : "tab"}
                  onClick={() => this.selectWeek("next")}
                >
                  <p>{lang.t("calendar:form.nextweek")}</p>
                  <div className="bg"></div>
                </div>
                <div
                  className={this.state.week === "three" ? "tab active" : "tab"}
                  onClick={() => this.selectWeek("three")}
                >
                  <p>
                    {lang.t("calendar:label.week")}{" "}
                    {Moment()
                      .add(14, "days")
                      .startOf("week")
                      .locale(lang.language)
                      .format("D MMM")}{" "}
                    -{" "}
                    {Moment()
                      .add(20, "days")
                      .startOf("week")
                      .locale(lang.language)
                      .format("D MMM")}
                  </p>
                  <div className="bg"></div>
                </div>
                <div
                  className={this.state.week === "four" ? "tab active" : "tab"}
                  onClick={() => this.selectWeek("four")}
                >
                  <p>
                    {lang.t("calendar:label.week")}{" "}
                    {Moment()
                      .add(21, "days")
                      .startOf("week")
                      .locale(lang.language)
                      .format("D MMM")}{" "}
                    -{" "}
                    {Moment()
                      .add(27, "days")
                      .startOf("week")
                      .locale(lang.language)
                      .format("D MMM")}
                  </p>
                  <div className="bg"></div>
                </div>
                <div className="tab" onClick={() => this.showOverlay("")}>
                  <p>Request contact</p>
                  <div className="bg"></div>
                </div>
              </div>
              <div className="clear"></div>
            </div>
            <div className="clear"></div>
            {this.renderContent()}
          </div>
          {this.renderOverlay()}
          {this.renderOverlayConfirm()}
          <Message />
        </div>
      );
    }
  }

  render() {
    return this.renderBase();
  }
}

export default withTranslation([
  "admin",
  "calendar",
  "common",
  "header",
  "modals",
  "messaging",
])(withRouter(MemberTrialPage));
